import { upload } from "../../../functions/Upload";
import { userHasAllRights } from "../../../functions/userRights";

export default {
  props: {
    folderId: String,
    mySpace: Number,
  },
  data() {
    return {
      dragging: false,
      checkInterval: null,
      lastUpdate: null,
      files: [],
    };
  },
  computed: {
    canDrop() {
      if (this.$store.state.user) {
        return userHasAllRights(["create_files", "create_folders"], this);
      }

      return false;
    },
  },
  methods: {
    handleDrop(e) {
      e.preventDefault();
      //check ME https://stackoverflow.com/questions/3590058/does-html5-allow-drag-drop-upload-of-folders-or-a-folder-tree
      this.dragging = false;

      const items = e.dataTransfer.items;

      if (items) {
        items.forEach((item) => {
          const fileItem = item.webkitGetAsEntry();

          if (fileItem) {
            this.checkAllFilesCollected();
            this.traverseFileTree(fileItem);
          }
        });
      }

      //has files so upload

      if (this.$refs.input) {
        this.$refs.input.value = null;
      }
    },
    traverseFileTree(item, path) {
      path = path || "";

      //set last time updated
      this.lastUpdate = new Date();

      if (item.isFile) {
        // Get file
        item.file((file) => {
          file.fullPath = path + file.name;

          this.files.push(file);
        });
      } else if (item.isDirectory) {
        this.hasFolder = true;

        // Get folder contents
        const dirReader = item.createReader();
        dirReader.readEntries((entries) => {
          entries.forEach((entry) => {
            this.traverseFileTree(entry, path + item.name + "/");
          });
        });
      }
    },
    checkAllFilesCollected() {
      this.checkInterval = setInterval(() => {
        const now = new Date();
        if (this.lastUpdate.getTime() + 300 < now) {
          //has not been updated in this time
          //clear the interval
          clearInterval(this.checkInterval);

          if (this.files.length) {
            //upload
            upload(
              {
                folderId: this.folderId,
                files: this.files,

                myspace: this.mySpace,
              },
              this
            );

            //clear files
            this.files = [];
          }
        }
      }, 300);
    },
    handleDragOver(e) {
      e.preventDefault();
    },
    dragEnter(e) {
      e.preventDefault();

      if (this.dragHasFiles(e.dataTransfer.types)) {
        this.dragging = true;
      }
    },
    dragLeave() {
      this.dragging = false;
    },
    dragHasFiles(types) {
      return types
        ? types.filter((type) => type.toLowerCase() === "files").length > 0
        : false;
    },
  },
  mounted() {
    document.body.addEventListener("dragenter", this.dragEnter);
    document.body.addEventListener("mouseout", this.dragLeave);
  },
  beforeDestroy() {
    document.body.removeEventListener("dragenter", this.dragEnter);
    document.body.removeEventListener("mouseout", this.dragLeave);
  },
  watch: {
    "$store.state.user"() {},
    files() {},
  },
};
